import { Job } from '@doc-abode/data-models';

export function isMultiAssigneeJob(job?: Job): boolean {
    if (!job) {
        return false;
    }

    return job.staffRequired === 2;
}
